import { render, staticRenderFns } from "./AdminCategories.vue?vue&type=template&id=02b9af90&"
import script from "./AdminCategories.vue?vue&type=script&lang=ts&"
export * from "./AdminCategories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports